import { Box, Link } from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import Paragraph from '../../shared/UI/Paragraph'

interface AbsenceWarningProps {
  maxDays: number
  employeeHandbookUrl?: string
}

export default function AbsenceDurationWarning({
  maxDays,
  employeeHandbookUrl,
}: AbsenceWarningProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        borderRadius: '14px',
        padding: '16px',
        backgroundColor: '#FEE4E2',
      }}
    >
      <InfoOutlinedIcon />
      <Box>
        <Paragraph weight="bold" size="14px">
          Maximum allowance of 
          {' '}
          {maxDays} 
          {' '}
          {maxDays === 1 ? 'day' : 'days'}
        </Paragraph>
        <Paragraph size="14px">
          More information can be found in the
          {' '}
          {employeeHandbookUrl ? (
            <Link
              href={employeeHandbookUrl}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: 'inherit',
                textDecoration: 'underline',
                '&:hover': {
                  textDecoration: 'underline',
                },
              }}
            >
              employee handbook
            </Link>
          ) : (
            'employee handbook'
          )}
        </Paragraph>
      </Box>
    </Box>
  )
}
